import React from 'react';
import PropTypes from 'prop-types';

const Form = (props) => (
  <form
    id={props.id}
    className={props.className}
    role="form"
    method={props.method}
    action={props.url}
    onSubmit={props.onSubmit}
  >
    {props.children}
    <button
      className="form-button"
      type="submit"
      value={props.submitLabel}
      disabled={props.disabled}
    >
      {props.submitLabel}
    </button>
  </form>
);

Form.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  method: PropTypes.oneOf('POST GET HEAD PUT DELETE OPTIONS CONNECT'.split(' ')),
  url: PropTypes.string,
  submitLabel: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

Form.defaultProps = {
  method: 'POST',
  disabled: false,
};

export default Form;
